
$(document).ready(function () {
    const historySwiperCard = new Swiper(".history-card-swiper", {
        wrapperClass: "history-card-wrapper",
        slideClass: "history-card",
        centeredSlides: true,
        slidesPerView: "auto",
        centerInsufficientSlides: true,
        autoHeight: true,
        spaceBetween: 300,
        navigation: {
            nextEl: ".history-header-button__next",
            prevEl: ".history-header-button__prev"
        },
        breakpoints: {
            1160: {
                spaceBetween: 280
            },
            768: {
                spaceBetween: 80
            },
            320: {
                spaceBetween: 14
            },
        }
    });

    historySwiperCard.snapGrid = [...historySwiperCard.slidesGrid];

    const historyLineSwiper = new Swiper(".history-timeline-container", {
        wrapperClass: "history-timeline-wrapper",
        slideClass: "history-timeline-item",
        slidesPerView: "auto",
        centeredSlides: true,
        centerInsufficientSlides: true,
        spaceBetween: 160,
        breakpoints: {
            1740: {
                spaceBetween: 300
            },
            1240: {
                spaceBetween: 260
            },
            980: {
                spaceBetween: 160
            },
            640: {
                spaceBetween: 100
            },
            420: {
                spaceBetween: 50
            }
        }
    });

    const historyTimelineWrapperPoints = document.querySelectorAll(
        `.history-timeline-item__point`
    );
    const historyTimelineLi = document.querySelectorAll(`.history-timeline-item`);

    // Modal functionality
    const historyCards = document.querySelectorAll(`.history-card`);
    const historyModalCards = document.querySelectorAll(`.history-modal-card`);

    const descriptionTitleBtn = document.querySelectorAll('.description-title_btn');
    const closeBtns = document.querySelectorAll(`.history-modal_close`);
    const historyModal = document.querySelector(`.history-modal`);
    const historyCardsButton = document.querySelectorAll(
        ".history-card_description-mobile_button"
    );
    const screenSmallSize = 1159;

    function initFirstPoint() {
        const firstSlideIdx = 0;
        historySwiperCard.slideTo(firstSlideIdx);
        const { activeIndex } = historySwiperCard;
        const activePoint = historyTimelineWrapperPoints[activeIndex];
        changeActivePoints(historyTimelineWrapperPoints, activePoint);
    }

    historySwiperCard.on("slideChange", () => {
        document.querySelectorAll(`.history-card`).forEach((card, indexCard) => {
            const descr = card.querySelector(
                ".history-card_description-mobile_text"
            );
            descr.classList.remove("active");
        });

        const { activeIndex } = historySwiperCard;
        const activePointOne = historyTimelineWrapperPoints[activeIndex];

        changeActivePoints(historyTimelineWrapperPoints, activePointOne);

        historyTimelineLi.forEach((el, idx) => {
            const activePoint = el.querySelector(
                `.history-timeline-item__point.active`
            );
            if (activePoint) {
                historyLineSwiper.slideTo(idx);
            }
        });

    });

    function setActiveSlideToTimeline() {
        historyTimelineLi.forEach((el, idx) => {
            el.addEventListener(`click`, () => {
                historyLineSwiper.slideTo(idx);
            });
        });
    }

    function changeActivePoints(arrPoints, el) {
        arrPoints.forEach((item) => {
            item.classList.remove(`active`);
        });
        el.classList.add(`active`);
    }

    function setActivePointTimeliToSlide() {
        historyTimelineWrapperPoints.forEach((el, idx) => {
            el.addEventListener(`click`, () => {
                changeActivePoints(historyTimelineWrapperPoints, el);
                historySwiperCard.slideTo(idx);
            });
        });
    }

    function showModal(card) {
        card.classList.remove("display-hidden");
        historyModal.classList.add("modal-active");
        document.body.style.overflow = "hidden";
    }

    function closeModal() {
        historyModal.classList.add("display-hidden");
        historyModal.classList.remove("modal-active");
        document.body.style.overflow = "";
    }

    function handlerModalInDesktop(sizeScreen) {
        if (window.innerWidth > sizeScreen) {
            descriptionTitleBtn.forEach((card, indexCard) => {
                card.addEventListener(`click`, () => {
                    historyModalCards.forEach((modalCard, indexModalCard) => {
                        if (indexModalCard === indexCard) {
                            showModal(modalCard);
                        } else {
                            modalCard.classList.add("display-hidden");
                        }
                    });
                });
            });

            closeBtns.forEach((item) => {
                item.addEventListener(`click`, closeModal);
            });

            historyModal.addEventListener("click", closeModal);

            document.addEventListener("keydown", (event) => {
                if (
                    event.code === "Escape" &&
                    historyModal.classList.contains("display-hidden")
                ) {
                    closeModal();
                }
            });
        }
    }

    //Modal mobile card


    function handlerOnClickTextDescr() {
        historyCardsButton.forEach((button, indexButton) => {
            button.addEventListener("click", () => {
                const imgButtonModal = button.querySelector("img");
                imgButtonModal.classList.toggle("button-active");

                historyCards.forEach((card, indexCard) => {
                    if (indexButton === indexCard) {
                        const descr = card.querySelector(
                            ".history-card_description-mobile_text"
                        );
                        descr.classList.toggle("active");
                        historySwiperCard.update();
                    }
                });
            });
        });
    }

    initFirstPoint();
    setActiveSlideToTimeline();
    setActivePointTimeliToSlide();

    handlerModalInDesktop(screenSmallSize);
    handlerOnClickTextDescr();

    const delay = (function () {
        let timer = 0;
        return function (callback, ms) {
            clearTimeout(timer);
            timer = setTimeout(callback, ms);
        };
    })();

    $(window).resize(function () {
        delay(function () {
            const historyCards = document.querySelectorAll(`.history-card`);
            const historyModalCards = document.querySelectorAll(`.history-modal-card`);

            const closeBtns = document.querySelectorAll(`.history-modal_close`);
            const historyModal = document.querySelector(`.history-modal`);
            const historyCardsButton = document.querySelectorAll(
                ".history-card_description-mobile_button"
            );

            historyCards.forEach((card, indexCard) => {
                const descr = card.querySelector(
                    ".history-card_description-mobile_text"
                );
                descr.classList.remove("active");
                historySwiperCard.update();
            });

            historyCardsButton.forEach((button) => {
                button.replaceWith(button.cloneNode(true));
            });

            historyCards.forEach((card) => {
                card.replaceWith(card.cloneNode(true));
            });

            document.querySelectorAll(
                ".history-card_description-mobile_button"
            ).forEach((button, indexButton) => {
                button.addEventListener("click", () => {
                    const imgButtonModal = button.querySelector("img");
                    imgButtonModal.classList.toggle("button-active");

                    document.querySelectorAll(`.history-card`).forEach((card, indexCard) => {
                        if (indexButton === indexCard) {
                            const descr = card.querySelector(
                                ".history-card_description-mobile_text"
                            );
                            descr.classList.toggle("active");
                            historySwiperCard.update();
                        }
                    });
                });
            });

            if (window.innerWidth <= screenSmallSize) {
                closeModal();
            }

            if (window.innerWidth > screenSmallSize) {
                document.querySelectorAll(`.description-title_btn`).forEach((card, indexCard) => {
                    card.addEventListener(`click`, () => {
                        historyModalCards.forEach((modalCard, indexModalCard) => {
                            if (indexModalCard === indexCard) {
                                showModal(modalCard);
                            } else {
                                modalCard.classList.add("display-hidden");
                            }
                        });
                    });
                });

                closeBtns.forEach((item) => {
                    item.addEventListener(`click`, closeModal);
                });

                historyModal.addEventListener("click", closeModal);

                document.addEventListener("keydown", (event) => {
                    if (
                        event.code === "Escape" &&
                        historyModal.classList.contains("display-hidden")
                    ) {
                        closeModal();
                    }
                });
            }
        }, 500);
    });
});

window.onload = (event) => {
    const valuesLink = document.getElementById('about-our-values');
    const historyLink = document.getElementById('about-history');
    const teamLink = document.getElementById('about-team');
    const aboutQuestionsLink = document.getElementById('about-questions');

    if (window.location.hash) {
        switch (window.location.hash.slice(1)) {
            case 'about-our-values':
                scrollToSomePosition(valuesLink.offsetTop);
                break;
            case 'about-history':
                scrollToSomePosition(historyLink.offsetTop);
                break;
            case 'about-team':
                scrollToSomePosition(teamLink.offsetTop);
                break;
            case 'about-questions':
                scrollToSomePosition(aboutQuestionsLink.offsetTop);
                break;
        }
    }

    function scrollToSomePosition(yOffset) {
        window.scrollTo(0, yOffset);
    }
};


const mainWrapper = document.querySelector('.wrapper');
const sectionOurValues = document.querySelector('.about-our-values');
const sectionOurValuesWrapper = sectionOurValues.querySelector('.about-our-values__wrapper');
const valuesCards = sectionOurValuesWrapper.querySelector('.about-our-values__values-cards');
const valuesCardsWrapper = valuesCards.querySelector('.about-our-values__values-cards-wrapper');

let lastScrollTop = document.documentElement.scrollTop;

setOverflowForWrapper();
setContainerHeight();
setValuesCardsWrapperWidth();
window.addEventListener('scroll', scrollHandler);

function setOverflowForWrapper() {
    mainWrapper.classList.add('wrapper-about');
}

function setContainerHeight() {
    const containerHeight = valuesCards.scrollWidth || 0;
    sectionOurValues.style.height = containerHeight + 'px';
}

function setValuesCardsWrapperWidth() {
    valuesCardsWrapper.style.width = valuesCards.scrollWidth + 45 + 'px';
}

function scrollHandler() {
    const distance = getScrollDistance();

    if (!isElementInViewport(sectionOurValues)) {
        sectionOurValuesWrapper.style.position = 'sticky';
        return;
    }

    sectionOurValuesWrapper.style.position = 'fixed';
    if (isTabletOrSmaller()) {
        valuesCards.scrollLeft += distance * 1.3;
    } else {
        valuesCards.scrollLeft += distance * 1.2;
    }
}

function isElementInViewport(el) {
    const rect = el.getBoundingClientRect();
    if (isTabletOrSmaller()) {
        return (rect.top <= -48) && (rect.bottom - 48 > document.documentElement.clientHeight);
    }
    return (rect.top <= -72) && (rect.bottom - 192 > document.documentElement.clientHeight);
}

function getScrollDistance() {
    const st = document.documentElement.scrollTop;
    const result = st - lastScrollTop;
    lastScrollTop = st;
    return result;
}

function isTabletOrSmaller() {
    return window.innerWidth <= 766;
}


let isCaptchaQuestionChecked = false;

const about_questions_form = document.getElementById('about-questions-feedbackForm');
const about_questions_submitBtn = document.getElementById('about-questions-feedback__submit');
const about_questions_name = document.getElementById('about-questions-feedbackForm__name');
const about_questions_phone = document.getElementById('about-questions-feedbackForm__phone');
const about_questions_email = document.getElementById('about-questions-feedbackForm__email');
const about_questions_question = document.getElementById('about-questions-feedbackForm__question');
const about_questions_closeSubmitedLetterBtn = document.querySelector('.about-questions-submitedLetter__close');

about_questions_submitBtn.setAttribute('disabled', true);

window.feedbackQuestionsCaptchaCallback = function () {
    isCaptchaQuestionChecked = true;
    if (validateFeedbackFormQuestions({ about_questions_name, about_questions_question, about_questions_phone, about_questions_email })) {
        about_questions_submitBtn.removeAttribute('disabled');
    } else {
        about_questions_submitBtn.setAttribute('disabled', true);
    }
};

about_questions_phone.addEventListener('input', (e) => {
    const position = e.target.value
        .replace(/\D/g, "")
        .match(/(\d{0,3})(\d{0,2})(\d{0,3})(\d{0,2})(\d{0,2})/);
    if (position) {
        e.target.value = '+' + position[0];
    }
});

about_questions_form.addEventListener('input', () => {
    hideMobileFeedbackQuestions()
    if (validateFeedbackFormQuestions({ about_questions_name, about_questions_question, about_questions_phone, about_questions_email })) {
        about_questions_submitBtn.removeAttribute('disabled');
    } else {
        about_questions_submitBtn.setAttribute('disabled', true);
    }
});

about_questions_submitBtn.addEventListener('click', submitButtonListenerQuestions);
about_questions_closeSubmitedLetterBtn.addEventListener('click', closeSubmitedLetterQuestions);

function validateEmailForSubscribeQuestions(value) {
    const emailSubscribeRegexp =
        /^[a-zA-Z0-9._-]+@[a-zA-Z0-9-]+\.[a-zA-Z]{2,4}$/g;
    return emailSubscribeRegexp.test(value);
}

function validateFeedbackFormQuestions(formData) {

    return formData.about_questions_name.value.trim().length > 0 &&
        formData.about_questions_question.value.trim().length > 19 &&
        formData.about_questions_phone.value.trim().length > 12 &&
        validateEmailForSubscribeQuestions(formData.about_questions_email.value) &&
        isCaptchaQuestionChecked;
}

function openSubmitedLetterQuestions() {
    const modalWindow = document.querySelector('.about-questions-submitedLetter__wrapper');
    const start_about_questions_form = document.querySelector('.about-questions-form');
    start_about_questions_form.scrollIntoView(true);
    disableScrolling();
    modalWindow.classList.remove('about-questions-submitedLetter__wrapper_hidden');
}

function closeSubmitedLetterQuestions() {
    const modalWindow = document.querySelector('.about-questions-submitedLetter__wrapper');
    enableScrolling();
    modalWindow.classList.add('about-questions-submitedLetter__wrapper_hidden');
}

function showMobileFeedbackQuestions() {
    const feedback = document.querySelector('.about-questions-feedback__mobile');
    feedback.classList.remove('about-questions-feedback__mobile-hidden');
    submitBtn.setAttribute('disabled', true);
}
function hideMobileFeedbackQuestions() {
    const feedback = document.querySelector('.about-questions-feedback__mobile');
    feedback.classList.add('about-questions-feedback__mobile-hidden');
}

function disableScrolling() {
    document.body.style.overflowY = 'hidden';
}
function enableScrolling() {
    document.body.style.overflowY = 'auto';
}

function submitButtonListenerQuestions(event) {
    event.preventDefault();
    sendFeedbackQuestions();
    about_questions_form .reset();
    const screenSm = 768;

    if (window.innerWidth < screenSm) {
        showMobileFeedbackQuestions();
    } else {
        openSubmitedLetterQuestions();
    }
}

function sendFeedbackQuestions() {
    const captcha = $("#g-recaptcha-response").val();
    const name = $("#about-questions-feedbackForm__name").val();
    const phone = $("#about-questions-feedbackForm__phone").val();
    const category = $('#about-questions-dropdown-container__email-topic').find(":selected").text();
    const text = $("#about-questions-feedbackForm__question").val();
    const email = $("#about-questions-feedbackForm__email").val();
    $.ajax({
        type: "POST",
        contentType: "application/json",
        dataType: "json",
        url: window.location.origin + "/umbraco/api/Mail/Create",
        data: JSON.stringify({
            "g-recaptcha-response": captcha,
            "FeedbackEmail": email,
            "FeedbackName": name,
            "FeedbackTheme": category,
            "FeedbackCategory": category,
            "FeedbackText": text,
            "PhoneNumber": phone
        })
    });
}





const accordion = document.getElementById("aboutQuestionsAccordion");
const accordionItems = accordion.querySelectorAll(".accordion-item");$(window).on('resize', resizeHandler);

accordionItems.forEach((item) => {
    const btn = item.querySelector('.accordion-item__btn-area');
    btn.addEventListener('click', setActiveAccordionItem);
});

function resizeHandler() {
    closeAccordionItems();
}

function closeAccordionItems() {
    accordionItems.forEach(item => {
        item.classList.remove('accordion-item_active');
    });
}

function setActiveAccordionItem(event) {
    const span = event.currentTarget;
    const accordionItem = span.closest('.accordion-item');
    closeTabsExceptOne(accordionItem.id);
}

function closeTabsExceptOne(accordionItemId) {
    accordionItems.forEach(item => {
        if (item.id === accordionItemId) {
            item.classList.toggle('accordion-item_active');
        } else {
            item.classList.remove('accordion-item_active');
        }
    });
}

resizeHandler();

const resultImgAnimation = document.querySelector(".work-results-img");
let isActive = false;
$(window).scroll(() => {
    const blockLocation = resultImgAnimation.getBoundingClientRect();
    const blockLocationHeight = blockLocation.height;
    const blockLocationAxisY = blockLocation.y;

    const getComparingScreenSize = (axisY, height) => {
        const two = 3;
        return axisY - height < -height / two;
    }

    const setTransformStyle = (element, value) => {
        return element.style.transform = value;
    };

    if (getComparingScreenSize(blockLocationAxisY, blockLocationHeight) && !isActive) {
        isActive = true;
        resultImgAnimation.classList.add('is-animated');
    }
});